import React from "react";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Moment from "react-moment";
import ParticleApi from "../Api/ParticleApi";
import SimChart from "./SimChart";

class ParticleSimDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      simDetails: null,
      productId: props.productId,
      iccid: props.iccid,
      simUsage: null,
    };
  }
  componentDidMount() {
    ParticleApi.getSimDetails(this.state.productId, this.state.iccid).then(
      (result) => {
        this.setState({
          isLoaded: true,
          simDetails: result.response,
        });
      },
      (error) => {
        this.setState({
          isLoaded: true,
          error,
        });
      }
    );

    ParticleApi.getSimUsage(this.state.productId, this.state.iccid).then(
      (result) => {
        this.setState({
          simUsage: result.response,
        });
      },
      (error) => {
        this.setState({
          error,
        });
      }
    );
  }
  render() {
    const { error, isLoaded, simDetails, simUsage } = this.state;
    if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return (
        <div>
          <CircularProgress color="secondary" />
        </div>
      );
    } else {
      return (
        <Paper>
          <Table classes={{ root: "reactivetable" }}>
            <TableBody>
              <TableRow>
                <TableCell component="th" scope="row">
                  Status
                </TableCell>
                <TableCell data-th="Status">{simDetails.status}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Last Status Change
                </TableCell>
                <TableCell data-th="Last Status Change">
                  {simDetails.updated_at ? (
                    <Moment format="YYYY-MM-DD HH:mm:ss Z">
                      {simDetails.updated_at}
                    </Moment>
                  ) : (
                    <div>-</div>
                  )}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Last Status Change Action
                </TableCell>
                <TableCell data-th="LastAction">
                  {simDetails.last_status_change_action}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Last Status Change Error
                </TableCell>
                <TableCell data-th="simDetails.last_status_change_action_error">
                  {simDetails.last_status_change_action_error}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell component="th" scope="row">
                  First Activated On
                </TableCell>
                <TableCell data-th="First Activated On">
                  {simDetails.first_activated_on ? (
                    <Moment format="YYYY-MM-DD HH:mm:ss Z">
                      {simDetails.first_activated_on}
                    </Moment>
                  ) : (
                    <div>-</div>
                  )}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Last Activated On
                </TableCell>
                <TableCell data-th="Last Activated On">
                  {simDetails.last_activated_on ? (
                    <Moment format="YYYY-MM-DD HH:mm:ss Z">
                      {simDetails.last_activated_on}
                    </Moment>
                  ) : (
                    <div>-</div>
                  )}
                </TableCell>
              </TableRow>
              {simDetails.mb_limit && (
                <TableRow>
                  <TableCell component="th" scope="row">
                    Limit
                  </TableCell>
                  <TableCell data-th="Limit">
                    {simDetails.mb_limit.toString()}mb
                  </TableCell>
                </TableRow>
              )}
              {simDetails.base_country_code && (
                <TableRow>
                  <TableCell component="th" scope="row">
                    Country Code
                  </TableCell>
                  <TableCell data-th="Country Code">
                    {simDetails.base_country_code}
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell component="th" scope="row">
                  Carrier
                </TableCell>
                <TableCell data-th="Carrier">{simDetails.carrier}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Total Usage
                </TableCell>
                <TableCell data-th="Total Usage">
                  {simUsage
                    ? simUsage.usage_by_day[simUsage.usage_by_day.length - 1]
                        .mbs_used_cumulative
                    : ""}{" "}
                  mb
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          {simUsage ? <SimChart data={simUsage.usage_by_day} /> : ""}
        </Paper>
      );
    }
  }
}

export default ParticleSimDetails;
